import { h } from 'preact'
import { Author } from './index.sync'
import UserAvatar from '../User/UserAvatar'
import ClampLines from 'react-clamp-lines'
import Icon from '../assets/'
import htmlParser from '../utils/htmlParser'
import LazyLoader from '../lazy-loading/LazyLoader'
import { common } from '../common'
import { ProductAreaType } from '../../control-components/product-areas/ProductAreaSelect'

interface IdeationStatus {
  name: string
  bgColor: string
  color: string
}

interface Props {
  content: string
  author: Author
  createdAt: string
  title: string
  url: string
  featuredImage: string
  label: string
  fullWidth: boolean
  customClass: string
  votesCount: number
  votes: string[]
  addVoteHandler: (id: number, hasCurrentUserVoted: boolean) => void
  index: number
  ideationStatus: IdeationStatus
  id: number
  hasCurrentUserVoted: boolean
  allProductAreas: ProductAreaType[]
  assignedProductAreas: string[]
}

const FeaturedIdeaView = ({ index, votesCount = 0, title, url, featuredImage, label, fullWidth, author, customClass = '', addVoteHandler, ideationStatus, content, createdAt, votes, hasCurrentUserVoted, assignedProductAreas, allProductAreas }: Props) => {
  const createTime = new Date(createdAt).getTime()
  hasCurrentUserVoted = hasCurrentUserVoted ?? (typeof window !== 'undefined' && votes.includes(window.inSidedData.user.userid))
  const productAreaMapping: {
    [key: string]: string
  } = {}
  allProductAreas.forEach(productArea => {
    productAreaMapping[productArea.id] = productArea.name
  })

  return (
    <article class={`featured-topic ${fullWidth ? 'featured-topic--full-width' : ''} ${featuredImage && 'featured-topic--featured-image'} ${customClass} featured-topic--idea`}>
      <button
        class={`featured-topic__vote ${hasCurrentUserVoted ? 'featured-topic__vote--voted' : ''}`}
        onClick={() => addVoteHandler(index, hasCurrentUserVoted)}
      >
        <span class='featured-topic__voteAmount'>{votesCount}</span>
        <Icon
          icon='triangle'
          width={10}
          height={8}
          customClass='featured-topic__voteIcon'
        />
      </button>
      <a href={url} class='featured-topic__url-link' />
      <div className='featured-topic__url card-widget-wrapper'>
        <div>
          {label &&
            <span className='topic__content-type-pill pill pill--uppercase pill--article qa-content-type-pill'>
              {label}
            </span>}
          {featuredImage &&
            <figure>
              <LazyLoader type='background' src={featuredImage} classNames='featured-topic__hero' alt={`Featured topic image ${index + 1}`} />
            </figure>}
        </div>
        <div className='featured-topic__title'>
          <h3
            className={`featured-topic__heading card-widget-title ${!featuredImage && label ? 'featured-topic__heading--no-image' : ''}`}
          >
            {title}
            <span
              className='topic__content-type-pill pill pill--uppercase pill--idea qa-content-type-pill'
              style={`background-color: ${ideationStatus.bgColor}; color: ${ideationStatus.color};`}
            >
              {ideationStatus.name}
            </span>
          </h3>
          {((typeof window !== 'undefined' && window.inSidedData?.device !== 'mobile' && fullWidth) || !featuredImage) &&
            <p className='card-widget-text'>
              <ClampLines
                id='featured-topic-view' lines={3} text={htmlParser.stripHtml(content) || ''}
                buttons={false}
              />
            </p>}
          {
            assignedProductAreas.length
              ? fullWidth
                ? (
                  <ul className='featured-topic__product-areas'>
                    {
                      assignedProductAreas.map(assignedProductArea => (
                        <li
                          key={assignedProductArea}
                          className='featured-topic__product-area'
                        >{productAreaMapping[assignedProductArea]}</li>
                      ))
                    }
                  </ul>
                  )
                : (
                  <ul className='featured-topic__product-areas'>
                    <li
                      className='featured-topic__product-area'
                    >{productAreaMapping[assignedProductAreas[0]]}</li>
                    {
                      assignedProductAreas.length > 1 && (
                        <li className='featured-topic__product-area-count' aria-label='Count of assigned product areas'>
                          {`+ ${assignedProductAreas.length - 1}`}
                        </li>
                      )
                    }
                  </ul>
                  )
              : null
          }
          <div className='post-meta__container'>
            <div className='post-meta__container--left'>
              <UserAvatar user={author} extraClass='avatar avatar--XS' />
              <span className='thread-meta-item__date'>
                {common.relativeDate(createTime)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </article>
  )
}
export default FeaturedIdeaView
